<template>
  <div class="wrapper">
    <!-- TODO: Refactor to use app-wrapper component -->
    <simple-header :header-click-route="headerClickRoute" />

    <div class="wrapper__content">
      <div class="wrapper__content-container">
        <div class="wrapper__content-mask">
          <router-view />
        </div>
      </div>
    </div>

    <main-footer />
  </div>
</template>



<script>
  import { mapGetters } from 'vuex';



  export default {
    name: 'WrapperPage',

    metaInfo() {
      const { merchant } = this;

      return {
        titleTemplate(titleChunk) {
          return titleChunk ? `${titleChunk} | ${merchant.name}` : merchant.name;
        }
      };
    },

    props: {
      headerClickRoute: {
        type: Object,
        default: null
      }
    },

    computed: {
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('merchant', ['merchant'])
    },

    created() {
      this.createdHandler();
    },

    methods: {
      async createdHandler() {
        await this.$store.dispatch('session/load');
      }
    }
  };
</script>
